import { render, staticRenderFns } from "./SjbqSubmit.vue?vue&type=template&id=16d057f0&scoped=true&"
import script from "./SjbqSubmit.vue?vue&type=script&lang=js&"
export * from "./SjbqSubmit.vue?vue&type=script&lang=js&"
import style1 from "../style.css?vue&type=style&index=1&id=16d057f0&prod&scoped=true&lang=css&"
import style2 from "./SjbqSubmit.vue?vue&type=style&index=2&id=16d057f0&prod&scoped=true&lang=less&"
import style3 from "./SjbqSubmit.vue?vue&type=style&index=3&id=16d057f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d057f0",
  null
  
)

export default component.exports